import bookingPageEn from "./en/bookingPage";
import bookingPageTh from "./th/bookingPage";
import cadidatePageTh from "./th/candidatePage";
import candidatePageEn from "./en/candidatePage";
import ExtraTextTh from "./th/extraText";
import ExtraTextEn from "./en/extraText";
import NavMenuTh from "./th/navigationMenu";
import NavMenuEn from "./en/navigationMenu";

export default {
  en: {
    bp: bookingPageEn,
    cp: candidatePageEn,
    extra: ExtraTextEn,
    nav: NavMenuEn,
  },
  th: {
    bp: bookingPageTh,
    cp: cadidatePageTh,
    extra: ExtraTextTh,
    nav: NavMenuTh,
  },
};
